var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasErrors)?_c('b-notification',{attrs:{"type":"is-danger"}},_vm._l((_vm.activeErrorMessages),function(error,index){return _c('div',{key:index},[_c('div',[_vm._v(_vm._s(error))])])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }